import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

export const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0"
        onClick={onClose}
      />
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-white rounded-lg p-6 w-full max-w-lg md:max-w-2xl lg:max-w-3xl relative mx-4"
      >
        {children}
      </motion.div>
    </div>
  );
};

export const CandidateDetailsModal = ({ isOpen, onClose, candidate }) => {
  if (!candidate) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative p-4 bg-white rounded-md shadow-lg mx-auto w-full max-w-md md:max-w-4xl max-h-screen overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <FaTimes className="w-5 h-5" />
        </button>

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg md:text-xl font-bold text-[#080366]">
            {candidate.candidateName}'s Details
          </h2>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6">
            {/* Contact Information */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#fbba00]">Contact Information</h3>
              <div className="grid grid-cols-1 gap-2">
                <div>
                  <span className="font-medium">Phone:</span>
                  <p className="text-gray-700">{candidate.phoneNumber}</p>
                </div>
                <div>
                  <span className="font-medium">Email:</span>
                  <p className="text-gray-700 break-words">{candidate.email}</p>
                </div>
                <div>
                  <span className="font-medium">Aadhar Card Number</span>
                  <p className="text-gray-700 break-words">{candidate.salaryExpectation || "N/A"}</p>
                </div>
              </div>
            </div>

            {/* Personal Information */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#fbba00]">Personal Information</h3>
              <div className="grid grid-cols-1 gap-2">
                <div>
                  <span className="font-medium">Gender:</span>
                  <p className="text-gray-700">{candidate.gender}</p>
                </div>
                <div>
                  <span className="font-medium">Type:</span>
                  <p className="text-gray-700">{candidate.type}</p>
                </div>
              </div>
            </div>

            {/* Education & Experience */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#fbba00]">Education & Experience</h3>
              <div className="grid grid-cols-1 gap-2">
                <div>
                  <span className="font-medium">Education:</span>
                  <p className="text-gray-700">{candidate.education}</p>
                </div>
                <div>
                  <span className="font-medium">Experience:</span>
                  <p className="text-gray-700">{candidate.experience} years</p>
                </div>
              </div>
            </div>

            {/* Location Information */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#fbba00]">Location Information</h3>
              <div className="grid grid-cols-1 gap-2">
                <div>
                  <span className="font-medium">Native State:</span>
                  <p className="text-gray-700">{candidate.nativeState}</p>
                </div>
                <div>
                  <span className="font-medium">Native District:</span>
                  <p className="text-gray-700">{candidate.nativeDistrict}</p>
                </div>
              </div>
            </div>

            {/* Skills */}
            <div className="space-y-3">
              <h3 className="font-semibold text-[#fbba00]">Skills</h3>
              <div className="flex flex-wrap gap-2">
                {candidate.skillsCategory.map((skill, index) => (
                  <span
                    key={index}
                    className="bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-700"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
